import { Module } from 'vuex'

import { GetProblemDescriptionUseCase } from '@/application/problem/getProblemDescriptionUseCase'
import { ProblemDescription } from '@/domain/entities/problem/problemDescription'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

interface ProblemDescriptionState {
  problemDescription: ProblemDescription
  isLoading: boolean
  error: string | null
}

export const problemDescriptionModule = (
  problemRepository: ProblemRepository
): Module<ProblemDescriptionState, any> => {
  const getProblemDescriptionUseCase = new GetProblemDescriptionUseCase(problemRepository)

  return {
    namespaced: true,
    state: {
      problemDescription: {
        problemId: '',
        displayLanguage: 'English',
        html: '',
        timeLimit: 0,
        memoryLimit: 0,
        commentaries: [],
        createdAt: new Date(),
        serverTime: 0,
        solvedUser: 0,
        successRate: 0,
        score: 0,
        recommend: false,
        recommendations: 0,
        bookmarks: [],
        isSolved: false,
        source: null,
        language: 'en'
      },
      isLoading: false,
      error: null
    },
    mutations: {
      setProblemDescription(state, problemDescription: ProblemDescription) {
        state.problemDescription = problemDescription
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async getProblemDescription(
        { commit },
        { displayLanguage, problemId }: { displayLanguage: DisplayLanguageType; problemId: string }
      ) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const res = await getProblemDescriptionUseCase.getProblemDescription(displayLanguage, problemId)
          commit('setProblemDescription', res)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      problemDescription: state => state.problemDescription,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
